
if (typeof window.hasBadgeMetafield !== 'function') {
  window.hasBadgeMetafield = (product) => {
    if (!product || typeof product !== 'object') {
      return false;
    }

    if (
        window.masterBadgeConfig &&
        window.masterBadgeConfig.collectionId &&
        product.collection_ids &&
        Array.isArray(product.collection_ids)
    ) {
      const collectionIds = product.collection_ids.map((c) => {
        if (typeof c === 'number') return c;
        if (typeof c === 'object' && c.id) return c.id;
        return parseInt(c, 10) || c;
      });
      if (collectionIds.includes(window.masterBadgeConfig.collectionId)) {
        return true;
      }
    }

    if (
        !product.selected_variant ||
        !product.selected_variant.metafields ||
        !product.selected_variant.metafields.custom
    ) {
      return false;
    }

    const metafieldsObj = product.selected_variant.metafields.custom;

    if (
        metafieldsObj.new_badge === 'true' ||
        metafieldsObj.include_as_seasonal_color === 'true' ||
        metafieldsObj.limited_edition_badge === 'true' ||
        (metafieldsObj.badge_pdp && metafieldsObj.badge_pdp !== '')
    ) {
      return true;
    }
    return false;
  };
}

if (typeof window.getBadgeMetafield !== 'function') {
  window.getBadgeMetafield = (product) => {
    if (!product || typeof product !== 'object') {
      return null;
    }

    if (
        window.masterBadgeConfig &&
        window.masterBadgeConfig.collectionId &&
        window.masterBadgeConfig.badgeText &&
        product.collections &&
        Array.isArray(product.collections)
    ) {
      const collectionIds = product.collections.map((c) => {
        if (typeof c === 'number') return c;
        if (typeof c === 'object' && c.id) return c.id;
        return parseInt(c, 10) || c;
      });
      if (collectionIds.includes(window.masterBadgeConfig.collectionId)) {
        return window.masterBadgeConfig.badgeText;
      }
    }

    if (
        !product.selected_variant ||
        !product.selected_variant.metafields ||
        !product.selected_variant.metafields.custom
    ) {
      return null;
    }

    const metafieldsObj = product.selected_variant.metafields.custom;
    if (metafieldsObj.badge_pdp && metafieldsObj.badge_pdp !== '') {
      return metafieldsObj.badge_pdp;
    }
    if (metafieldsObj.new_badge === 'true') {
      return 'New Arrival';
    }
    if (metafieldsObj.include_as_seasonal_color === 'true') {
      return 'New Color';
    }
    if (metafieldsObj.limited_edition_badge === 'true') {
      return 'Limited Edition';
    }

    return null;
  };
}

if (typeof window.getBadgeClass !== 'function') {
  window.getBadgeClass = (product) => {
    if (!product || typeof product !== 'object') {
      return 'badge--new';
    }

    if (
        window.masterBadgeConfig &&
        window.masterBadgeConfig.collectionId &&
        product.collection_ids &&
        Array.isArray(product.collection_ids)
    ) {
      const collectionIds = product.collection_ids.map((c) => {
        if (typeof c === 'number') return c;
        if (typeof c === 'object' && c.id) return c.id;
        return parseInt(c, 10) || c;
      });
      if (collectionIds.includes(window.masterBadgeConfig.collectionId)) {
        return 'badge--master';
      }
    }

    if (
        !product.selected_variant ||
        !product.selected_variant.metafields ||
        !product.selected_variant.metafields.custom
    ) {
      return 'badge--new';
    }

    const metafieldsObj = product.selected_variant.metafields.custom;
    if (metafieldsObj.badge_pdp && metafieldsObj.badge_pdp !== '') {
      return 'badge--custom';
    }
    if (metafieldsObj.new_badge === 'true') {
      return 'badge--new';
    }
    if (metafieldsObj.show_seasonal_color === 'true') {
      return 'badge--new-color';
    }
    if (metafieldsObj.limited_edition_badge === 'true') {
      return 'badge--limited';
    }

    return 'badge--new';
  };
}

const REBUY_SWIPER_FOCUSABLE_SELECTOR =
    'a[href], button, input, select, textarea, [tabindex]';

const getRebuySwiperSlides = (swiper) =>
    Array.from(swiper?.slides || swiper?.el?.querySelectorAll('.swiper-slide') || []);

const isRebuyFocusable = (el) =>
    el &&
    !el.disabled &&
    el.tabIndex >= 0 &&
    el.getClientRects().length > 0 &&
    !el.closest('[aria-hidden="true"], [inert]');

const getRebuyFocusableElements = (scope) =>
    Array.from(scope?.querySelectorAll(REBUY_SWIPER_FOCUSABLE_SELECTOR) || []).filter(
        isRebuyFocusable
    );

const getRebuyVisibleSlides = (swiper) => {
  const slides = getRebuySwiperSlides(swiper);
  const visibleSlides = slides.filter((slide) =>
      slide.classList.contains('swiper-slide-visible')
  );

  if (visibleSlides.length) {
    return visibleSlides;
  }

  const swiperRect = swiper.el.getBoundingClientRect();
  const isHorizontal =
      typeof swiper.isHorizontal === 'function'
          ? swiper.isHorizontal()
          : swiper.params.direction !== 'vertical';

  return slides.filter((slide) => {
    const slideRect = slide.getBoundingClientRect();
    const visibleSize = isHorizontal
        ? Math.min(slideRect.right, swiperRect.right) -
        Math.max(slideRect.left, swiperRect.left)
        : Math.min(slideRect.bottom, swiperRect.bottom) -
        Math.max(slideRect.top, swiperRect.top);

    return visibleSize > 1;
  });
};

const syncRebuySlideFocusability = (slide, isVisible) => {
  const focusableElements = Array.from(
      slide.querySelectorAll(REBUY_SWIPER_FOCUSABLE_SELECTOR)
  );

  if (isVisible) {
    slide.removeAttribute('aria-hidden');
  } else {
    slide.setAttribute('aria-hidden', 'true');
  }

  focusableElements.forEach((el) => {
    if (isVisible) {
      if (!el.hasAttribute('data-rebuy-original-tabindex')) {
        return;
      }

      const originalTabindex = el.getAttribute('data-rebuy-original-tabindex');
      if (originalTabindex) {
        el.setAttribute('tabindex', originalTabindex);
      } else {
        el.removeAttribute('tabindex');
      }
      el.removeAttribute('data-rebuy-original-tabindex');
      return;
    }

    if (el.tabIndex < 0 || el.hasAttribute('data-rebuy-original-tabindex')) {
      return;
    }

    el.setAttribute(
        'data-rebuy-original-tabindex',
        el.getAttribute('tabindex') || ''
    );
    el.setAttribute('tabindex', '-1');
  });
};

const syncRebuySwiperFocusability = (swiper) => {
  const slides = getRebuySwiperSlides(swiper);
  if (!slides.length) {
    return;
  }

  let visibleSlides = getRebuyVisibleSlides(swiper);
  if (!visibleSlides.length && slides[swiper.activeIndex]) {
    visibleSlides = [slides[swiper.activeIndex]];
  }

  const visibleSlideSet = new Set(visibleSlides);
  slides.forEach((slide) => {
    syncRebuySlideFocusability(slide, visibleSlideSet.has(slide));
  });
};

const getRebuyFocusHandoffSlide = (swiper, direction) => {
  const visibleSlides = getRebuyVisibleSlides(swiper).filter(
      (slide) => getRebuyFocusableElements(slide).length > 0
  );

  if (!visibleSlides.length) {
    return null;
  }

  return direction === 'prev'
      ? visibleSlides[visibleSlides.length - 1]
      : visibleSlides[0];
};

const focusRebuyProductAfterNavigation = (swiper, direction) => {
  if (!swiper || swiper.destroyed) {
    return;
  }

  let completed = false;
  let fallbackTimer = null;

  const cleanup = () => {
    if (typeof swiper.off === 'function') {
      swiper.off('transitionEnd', focusTarget);
      swiper.off('slideChangeTransitionEnd', focusTarget);
    }
    if (fallbackTimer) {
      window.clearTimeout(fallbackTimer);
    }
  };

  const focusTarget = () => {
    if (completed || swiper.destroyed) {
      return;
    }

    completed = true;
    cleanup();
    syncRebuySwiperFocusability(swiper);

    const targetSlide = getRebuyFocusHandoffSlide(swiper, direction);

    if (!targetSlide) {
      return;
    }

    const focusableElements = getRebuyFocusableElements(targetSlide);
    const target =
        direction === 'next'
            ? focusableElements[0]
            : focusableElements[focusableElements.length - 1];

    if (target) {
      target.focus({ preventScroll: true });
    }
  };

  if (typeof swiper.on === 'function') {
    swiper.on('transitionEnd', focusTarget);
    swiper.on('slideChangeTransitionEnd', focusTarget);
  }

  fallbackTimer = window.setTimeout(
      focusTarget,
      (swiper.params?.speed || 300) + 100
  );
};

const getRebuyNavigationButtonElement = (swiper, direction) => {
  const selector =
      direction === 'next' ? '.swiper-button-next' : '.swiper-button-prev';

  return swiper?.el?.querySelector(selector) || null;
};

const getRebuyNavigationButton = (swiper, direction) => {
  const button = getRebuyNavigationButtonElement(swiper, direction);

  if (!button || button.classList.contains('swiper-button-disabled')) {
    return null;
  }

  if (!button.hasAttribute('role')) {
    button.setAttribute('role', 'button');
  }
  if (!button.hasAttribute('aria-label')) {
    button.setAttribute(
        'aria-label',
        direction === 'next' ? 'Next products' : 'Previous products'
    );
  }
  if (!button.hasAttribute('tabindex') || button.tabIndex < 0) {
    button.setAttribute('tabindex', '0');
  }
  if (button.dataset.rebuyKeyboardBound !== 'true') {
    button.dataset.rebuyKeyboardBound = 'true';
    button.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      button.click();
    });
  }

  return button;
};

const wireRebuyNavigationButtons = (swiper) => {
  ['prev', 'next'].forEach((direction) => {
    const button = getRebuyNavigationButtonElement(swiper, direction);
    if (!button || button.dataset.rebuyFocusHandoffBound === 'true') {
      return;
    }

    button.dataset.rebuyFocusHandoffBound = 'true';
    button.addEventListener(
        'click',
        () => {
          if (
              document.activeElement !== button ||
              button.classList.contains('swiper-button-disabled')
          ) {
            return;
          }

          focusRebuyProductAfterNavigation(swiper, direction);
        },
        true
    );
  });
};

const wireRebuySwiperFocusHandoff = (swiper) => {
  const grid = swiper?.el;
  if (!grid || grid.dataset.rebuySwiperFocusHandoffBound === 'true') {
    return;
  }

  grid.dataset.rebuySwiperFocusHandoffBound = 'true';

  const sync = () => syncRebuySwiperFocusability(swiper);
  sync();
  wireRebuyNavigationButtons(swiper);
  swiper.on('slideChange', sync);
  swiper.on('transitionEnd', sync);
  swiper.on('update', sync);
  swiper.on('resize', sync);

  grid.addEventListener(
      'keydown',
      (event) => {
        if (event.key !== 'Tab' || event.defaultPrevented) {
          return;
        }

        const visibleFocusableElements = getRebuyVisibleSlides(swiper).flatMap(
            getRebuyFocusableElements
        );

        if (!visibleFocusableElements.length) {
          return;
        }

        const firstFocusable = visibleFocusableElements[0];
        const lastFocusable =
            visibleFocusableElements[visibleFocusableElements.length - 1];

        if (!event.shiftKey && event.target === lastFocusable) {
          const nextButton = getRebuyNavigationButton(swiper, 'next');
          if (nextButton) {
            event.preventDefault();
            nextButton.focus({ preventScroll: true });
          }
          return;
        }

        if (event.shiftKey && event.target === firstFocusable) {
          const prevButton = getRebuyNavigationButton(swiper, 'prev');
          if (prevButton) {
            event.preventDefault();
            prevButton.focus({ preventScroll: true });
          }
        }
      },
      true
  );
};

const initializeRebuySwiper = (
    el,
    direction = 'vertical',
    slidesPerView = 'auto',
    spaceBetween = 0
) => {
  const nextButton = el.querySelector('.swiper-button-next');
  const prevButton = el.querySelector('.swiper-button-prev');
  const paginationEl = el.querySelector('.swiper-pagination-mobile');
  const wrapper = el.querySelector('.swiper-wrapper');

  if (direction === 'vertical') {
    el.style.height = '100vh';
    el.style.overflow = 'hidden';
    if (wrapper) {
      wrapper.style.height = 'auto';
    }
  }

  const parsedSlidesPerView =
      slidesPerView === 'auto' ? 'auto' : parseFloat(slidesPerView);

  const swiperConfig = {
    direction: direction,
    slidesPerView: parsedSlidesPerView,
    spaceBetween: spaceBetween,
    autoHeight: false,
    watchSlidesProgress: true,
    a11y: {
      scrollOnFocus: false,
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true,
      sensitivity: 1,
    },
    freeMode: {
      enabled: true,
      sticky: false,
    },
    grabCursor: true,
  };

  if (nextButton && prevButton) {
    swiperConfig.navigation = {
      nextEl: nextButton,
      prevEl: prevButton,
    };
  }
  if (window.innerWidth < 600) {
    swiperConfig.slidesPerView = parsedSlidesPerView;
    swiperConfig.spaceBetween = spaceBetween || 10;
    swiperConfig.freeMode = false;
    swiperConfig.mousewheel = false;
    swiperConfig.grabCursor = false;
    swiperConfig.loop = true;

    if (paginationEl) {
      swiperConfig.pagination = {
        el: paginationEl,
        clickable: true,
        type: 'bullets',
        dynamicBullets: true,
      };
    }
  }
  const swiper = new Swiper(el, swiperConfig);
  wireRebuySwiperFocusHandoff(swiper);

  if (direction === 'vertical') {
    swiper.on('slideChange', () => {
      swiper.update();
      syncRebuySwiperFocusability(swiper);
    });
  }

  return swiper;
};

const getRebuyWidgetsById = () => {
  if (!window.Rebuy || !Array.isArray(window.Rebuy.widgets)) {
    return null;
  }

  return Object.fromEntries(
      window.Rebuy.widgets.map((widget) => [String(widget.id), widget])
  );
};

const getPanelWidgetElement = (panel) => {
  if (!panel?.dataset?.rebuyId) {
    return null;
  }

  return panel.querySelector(`[id="rebuy-widget-${panel.dataset.rebuyId}"]`);
};

const updatePanelSwiper = (panel, reset = false) => {
  const productGrid = panel?.querySelector('.rebuy-product-grid.swiper');
  if (!productGrid) {
    return;
  }

  const update = () => {
    if (productGrid.swiper && typeof productGrid.swiper.update === 'function') {
      productGrid.swiper.update();
      if (reset && typeof productGrid.swiper.slideTo === 'function') {
        productGrid.swiper.slideTo(0, 0);
      }
    }
  };

  requestAnimationFrame(() => {
    update();
    setTimeout(update, 100);
  });
};

const initializeAccordion = (accordionElement = null) => {
  if (!accordionElement) {
    const accordions = document.querySelectorAll('.rebuy-accordion');
    let initialized = false;
    accordions.forEach((accordion) => {
      initialized = initializeAccordion(accordion) || initialized;
    });
    return initialized;
  }

  const accordion = accordionElement;

  const toggles = accordion.querySelectorAll('.rebuy-accordion-toggle');
  const panels = accordion.querySelectorAll('.rebuy-accordion-panel');

  if (!toggles.length || !panels.length) {
    return false;
  }

  const widgetsById = getRebuyWidgetsById();
  if (!widgetsById) {
    return false;
  }

  const allTogglesAndPanels = accordion.querySelectorAll(
      '.rebuy-accordion-toggle, .rebuy-accordion-panel'
  );

  panels.forEach((panel, i) => {
    const widget = widgetsById[String(panel.dataset.rebuyId)];
    if (widget && toggles[i]) {
      const superTitle = widget.data.config?.language?.super_title;
      if (superTitle && superTitle.trim() !== '') {
        toggles[i].textContent = superTitle;
      }

      const widgetElement = getPanelWidgetElement(panel);

      if (widgetElement) {
        const productGrid = widgetElement.querySelector('.rebuy-product-grid');
        if (
            productGrid &&
            !productGrid.classList.contains('swiper-initialized') &&
            (panel.dataset.direction || productGrid.dataset.carouselDirection)
        ) {
          const direction =
              panel.dataset.direction || productGrid.dataset.carouselDirection;
          const slidesPerView = panel.dataset.slidesPerView || 'auto';
          const spaceBetween = panel.dataset.spaceBetween
              ? parseInt(panel.dataset.spaceBetween, 10)
              : 0;
          productGrid.setAttribute('data-direction', direction);
          try {
            initializeRebuySwiper(
                productGrid,
                direction,
                slidesPerView,
                spaceBetween
            );
            productGrid.classList.add('swiper-initialized');
            const drawerFooterSlider = document.querySelector(
                '.drawer__footer_slider'
            );
            if (drawerFooterSlider) {
              drawerFooterSlider.classList.add('swiper-initialized');
            }
          } catch (error) {
            console.error('Swiper initialization error:', error);
          }
        }
      }
    }
  });

  toggles.forEach((toggle, i) => {
    if (toggle.dataset.rebuyAccordionBound === 'true') {
      return;
    }

    toggle.dataset.rebuyAccordionBound = 'true';
    toggle.addEventListener('click', () => {
      allTogglesAndPanels.forEach((el) => el.classList.remove('is-active'));
      toggles.forEach((currentToggle, toggleIndex) => {
        currentToggle.classList.toggle('is-active', toggleIndex === i);
      });
      panels.forEach((panel, panelIndex) => {
        const isActivePanel = panelIndex === i;
        panel.classList.toggle('is-active', isActivePanel);
        panel.querySelectorAll("[id^='rebuy-widget']").forEach((widgetElement) => {
          if (isActivePanel) {
            widgetElement.removeAttribute('inert');
          } else {
            widgetElement.setAttribute('inert', '');
          }
        });
      });

      updatePanelSwiper(panels[i], true);
      window.dispatchEvent(new Event('resize'));
    });
  });

  updatePanelSwiper(accordion.querySelector('.rebuy-accordion-panel.is-active'));

  return true;
};
const tryInitializeAccordion = (maxRetries = 20, retryDelay = 500) => {
  let retries = 0;
  const attempt = () => {
    const panels = document.querySelectorAll('.rebuy-accordion-panel');
    if (!panels.length) {
      return;
    }

    let allWidgetsFound =
        window.Rebuy && Array.isArray(window.Rebuy.widgets);

    panels.forEach((panel) => {
      if (!getPanelWidgetElement(panel)) {
        allWidgetsFound = false;
      }
    });

    if (allWidgetsFound || retries >= maxRetries) {
      initializeAccordion();
    } else {
      retries++;
      setTimeout(attempt, retryDelay);
    }
  };
  attempt();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    tryInitializeAccordion();
  });
} else {
  tryInitializeAccordion();
}

window.addEventListener('resize', () => {
  initializeAccordion();
});
document.addEventListener('rebuy.productsChange', () => {
  tryInitializeAccordion();
});
document.addEventListener('rebuy:widget.loaded', () => {
  tryInitializeAccordion();
});
